// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JLPti","tooltipIcon":"styles_tooltipIcon__LyslT","subTitle":"styles_subTitle__8yf7D","header":"styles_header__zT7h1"};